export const STATUS_ACCEPTED = 'accepted';
export const STATUS_DECLINED = 'declined';
export const STATUS_PENDING = 'pending';
